import "bootstrap/dist/css/bootstrap.min.css";
import "./Footer.css";
import {
  faHouse,
  faCircleInfo,
  faGear,
  faCommentDots,
  faQuestion,
  faMapMarkerAlt,
  faEnvelope,
  faEnvelopeOpen,
  faPhone,
  faCalendarCheck,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faYoutube,
  faXTwitter,
  faLinkedin,
  faFacebook,
  faWhatsapp,
  faInstagram,
} from "@fortawesome/free-brands-svg-icons";

const Footer = ({ onBookConsultant }) => {
  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) section.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="footerparent">
      <section className="info_section">
        <div className="container">

          {/* GRID: Address + Links */}
          <div className="footer-grid">

            {/* ADDRESS */}
            <div className="footer-address">
              <h4>Contact Us</h4>

              <div className="icon-text">
                <a
                  href="https://www.google.com/maps/place/17%C2%B025'42.7%22N+78%C2%B025'38.7%22E"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FontAwesomeIcon icon={faMapMarkerAlt} className="footer-icon map-open-icon" />
                </a>
                <a
                  href="https://www.google.com/maps/place/17%C2%B025'42.7%22N+78%C2%B025'38.7%22E"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="thissumtext"
                >
                  8-2-293, Plot No - 26, 2nd Floor, Banjara Hills, Srinagar Colony,
                  Khairatabad, Hyderabad – 500073, Telangana
                </a>
              </div>

              <div className="icon-text mail-wrapper">
                <FontAwesomeIcon icon={faEnvelope} className="footer-icon mail-closed" />
                <FontAwesomeIcon icon={faEnvelopeOpen} className="footer-icon mail-open" />
                <a href="mailto:info@marsmateai.com" className="thissumtext">
                  info@marsmateai.com
                </a>
              </div>

              <div className="icon-text">
                <a href="tel:+919494075914">
                  <FontAwesomeIcon icon={faPhone} className="footer-icon address-phone-icon" />
                </a>
                <p className="thissumtext" style={{ margin: 0 }}>+91-9494075914</p>
              </div>

              {/* Book Consultancy text link */}
              <div className="icon-text footer-book-link" onClick={onBookConsultant}>
                <FontAwesomeIcon icon={faCalendarCheck} className="footer-icon" />
                <span className="thissumtext footer-book-text">Book Consultancy</span>
              </div>

              {/* Social icons */}
              <div className="social-icons">
                <a href="https://youtube.com/@marsmatebipvtltd?si=2Fys0ZQrmKdv8QpZ" target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIcon icon={faYoutube} id="youtubes" className="social-icon" />
                </a>
                <a href="https://www.facebook.com/share/1JnVwqqbey/" target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIcon icon={faFacebook} id="facebook" className="social-icon" />
                </a>
                <a href="https://x.com/MarsmateAI" target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIcon icon={faXTwitter} id="twittwers" className="social-icon" />
                </a>
                <a href="https://www.linkedin.com/company/marsmate-bi-private-limited/" target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIcon icon={faLinkedin} id="linkedin" className="social-icon" />
                </a>
                <a href="https://www.instagram.com/marsmate_ai" target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIcon icon={faInstagram} id="instagrams" className="social-icon" />
                </a>
                <a href="https://wa.me/919494075914?text=Hi" target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIcon icon={faWhatsapp} id="whatsapp" className="social-icon" />
                </a>
              </div>
            </div>

            {/* LINKS */}
            <div className="footer-links">
              <h4 className="linksname">Links</h4>
              <p className="thisissum link-item" onClick={() => scrollToSection("whys")}>
                <FontAwesomeIcon icon={faHouse} className="link-icon" />
                Home
              </p>
              <p className="thisissum link-item" onClick={() => scrollToSection("about")}>
                <FontAwesomeIcon icon={faCircleInfo} className="link-icon jump-icon" />
                About
              </p>
              <p className="thisissum link-item services-link" onClick={() => scrollToSection("services")}>
                <FontAwesomeIcon icon={faGear} className="link-icon services-rotate-icon" />
                Services
              </p>
              <p className="thisissum link-item" onClick={() => scrollToSection("getintouch")}>
                <FontAwesomeIcon icon={faCommentDots} className="link-icon vibrate-icon" />
                Requirements
              </p>
              <p className="thisissum link-item" onClick={() => scrollToSection("why")}>
                <FontAwesomeIcon icon={faQuestion} className="link-icon" />
                Why Us
              </p>
            </div>

          </div>
        </div>

        <section className="footer_section">
          <p>© {new Date().getFullYear()} All Rights Reserved By MarsMate Business Intelligence Pvt. Ltd.</p>
        </section>
      </section>
    </div>
  );
};

export default Footer;
